// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { API_BASE_URL, ENDPOINTS } from '@/config/api';

// Re-export API_BASE_URL from central configuration
export { API_BASE_URL };

// Export all from api
export * from './api';

/** Login API POST /api/auth/login */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>(`${API_BASE_URL}${ENDPOINTS.AUTH.LOGIN}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    // Credential failures belong to the form and are not active-session 401s.
    skipErrorHandler: true,
    data: body,
    ...(options || {}),
  });
}

/** Get current user information GET /api/auth/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<API.CurrentUser>(`${API_BASE_URL}${ENDPOINTS.AUTH.CURRENT_USER}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** Logout API POST /api/auth/logout */
export async function logout(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${API_BASE_URL}${ENDPOINTS.AUTH.LOGOUT}`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** Change password API PATCH /api/auth/change-password */
export async function changePassword(
  body: { currentPassword: string; newPassword: string },
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; message?: string }>(
    `${API_BASE_URL}${ENDPOINTS.AUTH.CHANGE_PASSWORD}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

// Alias exports for backward compatibility
export { getUsers as queryUsers } from './api';
